export const defaultTheme = {
  backgroundColor: "#006400", // dark green
  backgroundColorFocused: "#0a7b0a", // focused dark green
  // backgroundColor: "#00008B", // dark blue
  // backgroundColorFocused: "#0000CD", // focused dark blue (medium blue)
  color: "#ffffff",
  promptColor: "#00ff00",
  successColor: "#00ff00",
  errorColor: "#ff0000",
  warningColor: "#ffaa00", // Add if missing
  fontFamily: "monospace",
  borderRadius: "0px",
  // Scrollbar styling
  scrollbarWidth: "24px",
  scrollbarTrackColor: "rgba(0, 0, 0, 0.2)",
  scrollbarThumbColor: "rgba(255, 255, 255, 0.3)",
  scrollbarThumbHoverColor: "rgba(255, 255, 255, 0.5)",
};
